import { IEdgeVideos } from 'types';
import { VideoTemplateStateContent } from '../types';

export const getEdgeVideosOptions = (
  introOutro: VideoTemplateStateContent['introOutro'],
): IEdgeVideos => {
  const intro = introOutro?.intro
    ? { videoId: introOutro.intro.id }
    : undefined;
  const outro = introOutro?.outro
    ? { videoId: introOutro.outro.id }
    : undefined;
  return {
    intro,
    outro,
  };
};
